import VehicleBody from '../interfaces/VehicleBody'

const bodyTranslate = (type: string, body: string, bodies: VehicleBody[]): string => {
  const foundObject = bodies.find((obj) => obj.type === type && obj.body === body)

  return foundObject ? foundObject.description : 'Desconocido'
}

export default bodyTranslate
